// @ts-nocheck
import React, { useCallback } from 'react';
import {
  Box,
  Dialog,
  Grid,
  IconButton,
  Typography,
  Button,
  DialogActions,
  DialogContent,
  DialogTitle,
  Stack,
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import PropTypes from 'prop-types';
import DialogTransition from '../Transition/DialogTransition';
import { NOOP } from '../../../const/CommonConst';

const DeleteModal = ({
  open = false,
  handleClose = NOOP,
  deleteConfirm = NOOP,
  alertLabelText = '',
  warningText = '',
  deleteConfirmText = 'Delete',
  resourceName = '',
  isWarning = false,
}) => {
  const onClose = useCallback(() => {
    handleClose();
  }, [handleClose]);

  const onDelete = useCallback(() => {
    deleteConfirm();
    handleClose();
  }, [deleteConfirm, handleClose]);

  const getDialogTitle = () => {
    if (!resourceName) {
      return '';
    }

    const prefix = !isWarning ? deleteConfirmText : '';
    return `${prefix} ${resourceName}`.trim();
  };

  return (
    <Box>
      <Dialog
        maxWidth="xs"
        open={open}
        onClose={handleClose}
        TransitionComponent={DialogTransition}
      >
        <DialogTitle>
          <Box component="span" aria-live="polite" aria-atomic="true">
            {getDialogTitle()}
          </Box>
        </DialogTitle>

        <IconButton
          color="primary"
          aria-label="Close dialog"
          onClick={onClose}
          sx={{
            position: 'absolute',
            right: 16,
            top: 8,
          }}
        >
          <CloseIcon />
        </IconButton>
        <DialogContent dividers>
          <Grid container spacing={2}>
            {warningText && (
              <Grid item xs={12}>
                <Typography
                  variant="body4"
                  role="note"
                  aria-label={`Important note: ${warningText}`}
                >
                  <strong>Note:</strong>&nbsp;
                  <i>{warningText}</i>
                </Typography>
              </Grid>
            )}
            <Grid item xs={12}>
              <Typography
                variant="body1"
                align="center"
                role="note"
                aria-label={alertLabelText}
              >
                {alertLabelText}
              </Typography>
            </Grid>
          </Grid>
        </DialogContent>

        <DialogActions>
          <Stack direction="row" spacing={1}>
            <Button
              onClick={onDelete}
              variant="outlined"
              title={deleteConfirmText}
              size="small"
            >
              {deleteConfirmText}
            </Button>
            <Button
              variant="contained"
              title="Cancel"
              onClick={onClose}
              size="small"
            >
              Cancel
            </Button>
          </Stack>
        </DialogActions>
      </Dialog>
    </Box>
  );
};

DeleteModal.propTypes = {
  open: PropTypes.bool.isRequired,
  handleClose: PropTypes.func.isRequired,
  deleteConfirm: PropTypes.func.isRequired,
  alertLabelText: PropTypes.string.isRequired,
  warningText: PropTypes.string.isRequired,
  deleteConfirmText: PropTypes.string,
  resourceName: PropTypes.string.isRequired,
  isWarning: PropTypes.bool,
};

export default React.memo(DeleteModal);
